import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import { ThemeContext } from './Context';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { PwaPrompt } from 'react-ios-pwa-prompt-ts'
import { RWebShare } from "react-web-share";
import { useEffect, useState } from 'react';
import isiOS from 'is-ios';
import { useAddToHomescreenPrompt } from '../hooks/useAddToHomescreenPrompt';
import { moon, sun, geo_alt, clock_history, gear, apple, google_play, github, linkedin, MBTANearMe, share_fill, envelope_fill, facebook, twitter_x, reddit } from './Icons';
import { clearLocalStorage } from '../Utilities/storageUtils';
import { useTour } from '@reactour/tour'

function MainNavigation({ setCurrentPage = (_: string) => { }, currentPage = "" }) {
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [supportsPWA, setSupportsPWA] = useState(false);

  const regex = /android/i
  const { setIsOpen, setCurrentStep } = useTour();
  function showTour() {
    setShowMenu(false);
    setCurrentStep(0);
    setIsOpen(true);
  }
  const isAndroid = regex.test(navigator?.userAgent);

  useEffect(
    () => {
      if (prompt) {
        setSupportsPWA(true);
      }
    },
    [prompt]
  );

  const expand = false;
  const [showMenu, setShowMenu] = useState(false);
  const [iosPWAInstall, setiosPWAInstall] = useState(false);

  const handleCloseMenu = () => setShowMenu(false);
  const handleShowMenu = () => setShowMenu(true);

  const handleInstall = () => {
    if (isiOS) {
      setiosPWAInstall(true);
    } else if (supportsPWA) {
      promptToInstall();
    }
  }

  const resetApplication = () => {
    clearLocalStorage();
    caches.keys().then((keyList) => {
      Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        }))
    });
    document.location.href = "/";
  }

  return (
    <ThemeContext.Consumer>
      {value => {
        const { theme, switchTheme } = value;
        return (
          <Navbar fixed='bottom' className='bg-body-tertiary' expand={false}>
            <Container >
              <Nav variant="underline d-flex flex-row flex-fill mx-auto justify-content-between" >
                <Nav.Item className='w-100 text-center'>
                  <Nav.Link id='Map' onClick={() => setCurrentPage("Map")} className='d-flex justify-content-center flex-column' active={currentPage === "Map"}>
                    <div>{geo_alt}</div>
                    <span>Map</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className='w-100 text-center'>
                  <Nav.Link id='Schedules' onClick={() => setCurrentPage("Schedules")} className='d-flex justify-content-center flex-column' active={currentPage === "Schedules"}>
                    <div>{clock_history}</div>
                    <span>Schedules</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className='w-100 text-center'>
                  <Nav.Link id='Settings' className='d-flex justify-content-center flex-column' onClick={handleShowMenu} >
                    <div>{gear}</div>
                    <span>Settings</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
                show={showMenu}
                onHide={handleCloseMenu}
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                    <h1>{MBTANearMe(40, 40)}
                      <b>MBTA</b> Near Me</h1>
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className='h-100 d-flex flex-column justify-content-evenly ' >
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <Nav.Link id='Reset' onClick={resetApplication}>
                        Reset Application
                      </Nav.Link>
                    </Nav>
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <Nav.Link onClick={showTour}>
                        Launch Tutorial
                      </Nav.Link>
                    </Nav>
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <Form.Group className='d-flex flex-row'>
                        <Form.Label className='me-2'>Theme&nbsp;</Form.Label>
                        <Form.Check // prettier-ignore
                          type="switch"
                          id="light-switch"
                          label={(theme == "light" ? moon(20, 20, 'ms-1') : sun(20, 20, 'ms-1'))}
                          onClick={() => {
                            switchTheme(theme == "light" ? "dark" : "light");
                          }}
                        />
                      </Form.Group>
                    </Nav>
                    {(isiOS || supportsPWA) &&
                      <>
                        <hr />
                        <Nav className='d-flex flex-row justify-content-evenly w-100'>
                          {isAndroid &&
                            <Nav.Link href='https://play.google.com/store/apps/details?id=com.mbtanearme.twa' target='_blank'>
                              {google_play(24, 24)}
                              &nbsp;&nbsp;&nbsp;&nbsp;Install App
                            </Nav.Link>
                          }
                          {!isAndroid &&
                            <Nav.Link id='install' onClick={handleInstall}>
                              {isiOS && <>{apple(24, 24)}</>}
                              &nbsp;&nbsp;&nbsp;&nbsp;Install App
                            </Nav.Link>
                          }
                          <PwaPrompt
                            copyBody='Install app to easily access anytime.'
                            copyTitle='MBTA Near Me'
                            isOpen={iosPWAInstall}
                            transitionDuration={200}
                            onClose={() => {
                              setiosPWAInstall(false);
                            }}
                            skipStorageUpdate={true}
                          />
                        </Nav>
                      </>
                    }
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <RWebShare
                        data={{
                          text: "Find the closest MBTA T Station near you.",
                          url: "https://mbtanearme.com/",
                          title: "MBTA Near Me",
                        }}
                      >
                        <Nav.Link id='share-app' >
                          {share_fill(24, 24)}&nbsp;&nbsp;&nbsp;&nbsp;Share
                        </Nav.Link>
                      </RWebShare>

                    </Nav>
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <Nav.Link id='feedback' href={`mailto:feedback@mbtanearme.com?subject=Feedback%20on%20App${isiOS ? "%20-%20iOS" : (isAndroid ? "%20-%20Android" : "")}&body=I%20have%20some%20feedback.%20`}>
                        {envelope_fill(24, 24)}&nbsp;&nbsp;&nbsp;&nbsp;Feedback
                      </Nav.Link>
                    </Nav>
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100'>
                      <Nav.Link href='https://github.com/perabjoth' target='_' >
                        {github}
                      </Nav.Link>
                      <Nav.Item >
                        Built By <a href='https://linkedin.com/in/perabjoth' target='_'>Perabjoth</a>
                      </Nav.Item>
                      <Nav.Link href='https://linkedin.com/in/perabjoth' target='_' >
                        {linkedin}
                      </Nav.Link>
                    </Nav>
                    <hr />
                    <Nav className='d-flex flex-row justify-content-evenly w-100 text-body-secondary x-small'>
                      <Nav.Link href='/disclaimer' >Disclaimer</Nav.Link>
                      <Nav.Link href='/privacy' >Privacy</Nav.Link>
                      <Nav.Link href='/builtwith' >Built With</Nav.Link>
                    </Nav>
                    <Nav className='d-flex flex-row justify-content-evenly w-100 text-body-secondary x-small'>
                      <Nav.Link href='https://www.facebook.com/MBTANearMe' target='_'>{facebook()}</Nav.Link>
                      <Nav.Link href='https://twitter.com/MBTANearMe' target='_'>{twitter_x()}</Nav.Link>
                      <Nav.Link href='https://www.reddit.com/user/MBTANearMe' target='_'>{reddit()}</Nav.Link>
                    </Nav>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>)
      }
      }
    </ThemeContext.Consumer>
  );
}

export default MainNavigation;